import HistoryIcon from '@mui/icons-material/History';
import {
  AutocompleteInput,
  Filter,
  List,
  ReferenceInput,
  useListContext,
} from 'react-admin';
import { BetweenDatesTimesInput } from '../../components/BetweenDatesInput';
import ListPagination from '../../components/ListPagination';
import { filterToQuery } from '../../utils';
import { ChangeLogDatagrid } from './ChangeLogDatagrid';
import { getChainId } from '../../lib';

const PlaceFilter = (props: any) => {
  const { filterValues } = useListContext();
  return (
    <ReferenceInput
      {...props}
      source="entityId"
      reference="places"
      sort={{ field: 'name', order: 'ASC' }}
      perPage={100}
      filter={filterValues.chainId ? { chainId: filterValues.chainId } : {}}
    >
      <AutocompleteInput
        label="Posto"
        optionText="name"
        filterToQuery={filterToQuery}
        sx={{ minWidth: 200 }}
      />
    </ReferenceInput>
  );
};

const ListFilters = (props: any) => (
  <Filter {...props}>
    <BetweenDatesTimesInput alwaysOn />
    <ReferenceInput
      source="chainId"
      reference="chains"
      sort={{ field: 'name', order: 'ASC' }}
      perPage={9999}
      alwaysOn
    >
      <AutocompleteInput
        label="Rede"
        optionText="name"
        filterToQuery={filterToQuery}
        sx={{ minWidth: 200 }}
      />
    </ReferenceInput>
    <PlaceFilter alwaysOn />
  </Filter>
);

export const ChangeLogList = () => (
  <List
    filters={<ListFilters />}
    filterDefaultValues={{
      from: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString(),
      to: new Date().toISOString(),
      chainId: getChainId() || undefined,
    }}
    pagination={<ListPagination />}
    sort={{ field: 'changedAt', order: 'DESC' }}
    exporter={false}
    perPage={25}
  >
    <ChangeLogDatagrid showEntityColumns />
  </List>
);

export default ChangeLogList;
export { HistoryIcon as ChangeLogIcon };
